module.exports = "<div class=\"banner clearfix boxShadow borderRadius white_bg\" style=\"margin-top: 16px;\">\r\n    <header class=\"header f14r16 primaryTextColor\" v-if=\"showHeader\">\r\n        <span v-if=\"ad\">{{ad.title}}</span>\r\n    </header>\r\n    <div class=\"bannerBody clearfix\">\r\n        <a v-if=\"ad\" :data-id=\"ad.id\"  v-on:click=\"openUrl(ad.id,ad.url)\" >\r\n            <img class=\"fl\" :src=\"ad.img\" width=\"100%\" height=\"auto\" :alt=\"ad.title\"/>\r\n        </a>\r\n    </div>\r\n<!--    <footer class=\"footer secondaryTextColor\" v-if=\"showFooter\">广告</footer>-->\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/shixun-mobile/html/content_module/banner.mod
 ** module id = 251
 ** module chunks = 0 24
 **/